module.exports = __webpack_public_path__ + "8f6e4c8f6508af0922127479d15eaf39.png";